import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandingLogoDisplayComponent } from "../../branding/branding-logo-display/branding-logo-display.component";
import { NgIcon, provideIcons } from '@ng-icons/core';
import { bootstrapPersonBadge } from '@ng-icons/bootstrap-icons';
import { ChangePasswordFormComponent } from './change-password-form/change-password-form.component';

@Component({
  selector: 'app-user-configuration-modal',
  standalone: true,
  imports: [BrandingLogoDisplayComponent, NgIcon, ChangePasswordFormComponent],
  templateUrl: './user-configuration-modal.component.html',
  styleUrl: './user-configuration-modal.component.scss',
  viewProviders: [
    provideIcons({
      bootstrapPersonBadge
    })
  ]
})
export class UserConfigurationModalComponent {

  @Input()
  userData: any;

  menuMode: 'changePassword' | 'home' = 'home';

  constructor(protected activeModal: NgbActiveModal) { }

  setMenuMode(menuType: 'changePassword' | 'home') {
    this.menuMode = menuType;
  }

  setBackToHome() {

    this.setMenuMode('home');
  }
}
